export const Projects = [
  {
    title: "Live CMB",
    description: "A web application to find happening places & events",
    link: "https://livecmb.com/",
    linkText: "livecmb.com",
    tools: ["React", "Tailwind", "Firebase"],
  },
  {
    title: "Mobile-Lens Pro",
    description:
      "A desktop software that lets you use your mobile phone as a web camera.",
    link: "https://fir-demo-admin.web.app/",
    linkText: "mobilelens.pro",
    tools: ["Electron", "FFI", "React"],
  },
  {
    title: "TITA",
    description:
      "An E-Commerce website with React frontend & Serverless backend running on google cloud. (Work In Progress)",
    link: "https://tita-lk.web.app/",
    linkText: "https://tita-lk.web.app",
    tools: ["ReactJS", "Serverless", "GCloud"],
  },
  {
    title: "Sigen Store",
    description:
      "An E-Commerce website with shopping cart & online payments solution",
    link: "https://store.sigen.lk",
    linkText: "https://store.sigen.lk",
    tools: ["VueJS", "ExpressJS", "MongoDB"],
  },
  {
    title: "MONO ERP",
    description:
      "An ERP solution developed for small scale businesses with invoice generation",
    link: "https://monoerp.com/",
    linkText: "https://monoerp.com/",
    tools: ["ReactJS", "Serverless"],
  },
  {
    title: "President College",
    description:
      "React web app developed for President's College Nattandiya with dynamic content & a custom localization module",
    link: "https://presidentcollegenattandiya.lk/",
    linkText: "presidentcollegenattandiya.lk",
    tools: ["ReactJS", "Firebase", "SCSS"],
  },
  {
    title: "Pureshine",
    description:
      "A react website with serverless backend for handling emails developed for client provided designs",
    link: "https://pureshine.ae/",
    linkText: "pureshine.ae",
    tools: ["ReactJS", "Cloud Functions", "MailJet"],
  },
  {
    title: "OmaariLanka Tours",
    description:
      "A website developed using raw HTML with SCSS for a tourism business",
    link: "https://omaarilankatours.com",
    linkText: "omaarilankatours.lk",
    tools: ["HTML", "SASS"],
  },
  {
    title: "Zap Dash",
    description: "Hyper casual mobile game developed with Godot Engine",
    link: "https://play.google.com/store/apps/details?id=dash.zap&hl=en&gl=US",
    linkText: "play.google.com/zapdash",
    tools: ["Godot Engine", "GD Script"],
  },
  {
    title: "Hyped Climb",
    description: "Hyper casual mobile game developed with Unity Engine with C#",
    link: "https://play.google.com/store/apps/details?id=hyped.climb&hl=en_US&gl=US",
    linkText: "play.google.com/hypedclimb",
    tools: ["Unity3D", "C#"],
  },
];
